// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W6FB","importantInfo":"styles_importantInfo___AecP"};